import { JsonObject, JsonProperty } from 'json2typescript';
import { QuestionInterface } from '../interfaces/question.interface';
import { QuestionnaireInterface } from '../interfaces/questionnaire.interface';
import { QuestionModel } from './question.model';

@JsonObject('QuestionnaireModel')
export class QuestionnaireModel implements QuestionnaireInterface {
  @JsonProperty('HeaderDescription', String, true)
  headerDescription: string = undefined;

  @JsonProperty('Id', String, true)
  id: string = undefined;

  @JsonProperty('Name', String, true)
  name: string = undefined;

  @JsonProperty('Questions', [QuestionModel], true)
  questions: QuestionInterface[] = undefined;

  @JsonProperty('Type', String, true)
  type: string = undefined;
}
